var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.00726C4 2.71182 7.76157 0.830086 10.3987 2.8063L18.3961 8.79932C20.5311 10.3993 20.5311 13.6013 18.3961 15.2012L10.3987 21.1944C7.76161 23.1706 4 21.2889 4 17.9934V6.00726ZM9.19936 4.40678C7.88079 3.41867 6 4.35954 6 6.00726V17.9934C6 19.6412 7.8808 20.582 9.19937 19.5939L17.1967 13.6008C18.2642 12.8008 18.2642 11.1998 17.1967 10.3998L9.19936 4.40678Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLarge);
export default __webpack_public_path__ + "static/media/play-large.be2656df66e049d2836925c361d4dd2a.svg";
export { ForwardRef as ReactComponent };